import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || `http://${window.location.hostname}:5001`;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Request interceptor to add token
api.interceptors.request.use(
  (config) => {
    let token = sessionStorage.getItem('token'); // Use sessionStorage strictly for testing

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle network errors (no response from server)
    if (!error.response) {
      console.error('Network Error:', error.message);
      // Don't logout on network errors - user might just have temporary connection issues
      return Promise.reject(error);
    }

    if (error.response?.status === 401) {
      const isAuthEndpoint =
        error.config?.url?.includes('/auth/login') ||
        error.config?.url?.includes('/auth/verify-login') ||
        error.config?.url?.includes('/auth/forgotpassword') ||
        error.config?.url?.includes('/auth/resetpassword');

      // Only do a hard redirect if the user had a valid session that expired.
      // NEVER redirect during a fresh login/auth attempt — that causes the page
      // to reload and the user loses their typed credentials.
      const hadUser =
        !!localStorage.getItem('user') || !!sessionStorage.getItem('user');

      if (!isAuthEndpoint && hadUser) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export const getFileUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http') || url.startsWith('data:')) return url;
  
  const baseUrl = process.env.REACT_APP_API_URL || `http://${window.location.hostname}:5001`;
  const safeBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  const safeUrlPath = url.startsWith('/') ? url : `/${url}`;
  
  return `${safeBaseUrl}${safeUrlPath}`;
};

export default api;
